export default [
	{  // PC装修
		path: 'decorate_template_list_pc',
		name: 'm_decorate_template_pc',
		component: () => import('@/pages/decorate/decorate_template_pc')
	}, {  // 移动端装修模板
		path: 'decorate_template_list_wx',
		name: 'm_decorate_template_wx',
		component: () => import('@/pages/decorate/decorate_template_wx')
	}, {  // 广告管理
		path: 'advert_space_list',
		name: 'm_advert',
		component: () => import('@/pages/decorate/advert_space_list')
	}, {  // APP图标/背景
		path: 'app_style_temp_list',
		name: 'm_app_style',
		component: () => import('@/pages/decorate/app_style_temp_list')
	}, {  // APP图标/背景(编辑)
		path: 'app_style_temp_edit/:id',
		name: 'b_app_style_edit',
		meta: {
			title: '编辑APP图标/背景模板'
		},
		props: route => route.params,
		component: () => import('@/pages/decorate/app_style_temp_edit')
	}, {  // APP图标/背景(新增)
		path: 'app_style_temp_add',
		name: 'b_app_style_add',
		meta: {
			title: '新增APP图标/背景模板'
		},
		component: () => import('@/pages/decorate/app_style_temp_add')
	}, {  // APP启动页广告
		path: 'start_adv_temp_list',
		name: 'm_app_start_adv',
		component: () => import('@/pages/decorate/start_adv_temp_list')
	}, {  // APP图标/背景(编辑)
		path: 'start_adv_temp_edit/:id',
		name: 'b_app_start_adv_edit',
		meta: {
			title: '编辑APP启动广告模板'
		},
		props: route => route.params,
		component: () => import('@/pages/decorate/start_adv_temp_edit')
	}, {  // APP图标/背景(新增)
		path: 'start_adv_temp_add',
		name: 'b_app_start_adv_add',
		meta: {
			title: '新增APP启动广告模板'
		},
		component: () => import('@/pages/decorate/start_adv_temp_add')
	}
];